import { render } from "./productMarket.vue?vue&type=template&id=bf029cca&scoped=true"
import script from "./productMarket.vue?vue&type=script&lang=js"
export * from "./productMarket.vue?vue&type=script&lang=js"

import "./productMarket.vue?vue&type=style&index=0&id=bf029cca&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf029cca"]])

export default __exports__